"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paths = void 0;
// Fill icons
const AccurxLogo_1 = __importDefault(require("./Fill/AccurxLogo"));
const AddPerson_1 = __importDefault(require("./Fill/AddPerson"));
const ArrowOneWay_1 = __importDefault(require("./Fill/ArrowOneWay"));
const ArrowTwoWay_1 = __importDefault(require("./Fill/ArrowTwoWay"));
const Assign_1 = __importDefault(require("./Fill/Assignment/Assign"));
const Assigned_1 = __importDefault(require("./Fill/Assignment/Assigned"));
const Unassigned_1 = __importDefault(require("./Fill/Assignment/Unassigned"));
const Bell_1 = __importDefault(require("./Fill/Bell"));
const Carehome_1 = __importDefault(require("./Fill/Carehome"));
const ColumnThree_1 = __importDefault(require("./Fill/ColumnThree"));
const ColumnTwo_1 = __importDefault(require("./Fill/ColumnTwo"));
const Dot_1 = __importDefault(require("./Fill/Dot"));
const Error_1 = __importDefault(require("./Fill/Error"));
const Failed_1 = __importDefault(require("./Fill/Failed"));
const Flag_1 = __importDefault(require("./Fill/Flag"));
const HealthProfessional_1 = __importDefault(require("./Fill/HealthProfessional"));
const Hospital_1 = __importDefault(require("./Fill/Hospital"));
const Inbox_1 = __importDefault(require("./Fill/Inbox"));
const Info_1 = __importDefault(require("./Fill/Info"));
const Allowed_1 = __importDefault(require("./Fill/Lock/Allowed"));
const Denied_1 = __importDefault(require("./Fill/Lock/Denied"));
const Locked_1 = __importDefault(require("./Fill/Lock/Locked"));
const Unlocked_1 = __importDefault(require("./Fill/Lock/Unlocked"));
const More_1 = __importDefault(require("./Fill/More"));
const Person_1 = __importDefault(require("./Fill/Person"));
const Pin_1 = __importDefault(require("./Fill/Pin"));
const Question_1 = __importDefault(require("./Fill/Question"));
const ReviewPerson_1 = __importDefault(require("./Fill/ReviewPerson"));
const SearchPerson_1 = __importDefault(require("./Fill/SearchPerson"));
const Send_1 = __importDefault(require("./Fill/Send"));
const Star_1 = __importDefault(require("./Fill/Star"));
const Success_1 = __importDefault(require("./Fill/Success"));
const Team_1 = __importDefault(require("./Fill/Team"));
const Warning_1 = __importDefault(require("./Fill/Warning"));
// Line icons
const Account_1 = __importDefault(require("./Line/Account"));
const AccurxLogo_2 = __importDefault(require("./Line/AccurxLogo"));
const Arrow_1 = __importDefault(require("./Line/Arrow"));
const ArrowTail_1 = __importDefault(require("./Line/ArrowTail"));
const Assign_2 = __importDefault(require("./Line/Assign"));
const Assigned_2 = __importDefault(require("./Line/Assigned"));
const Bell_2 = __importDefault(require("./Line/Bell"));
const BellMute_1 = __importDefault(require("./Line/BellMute"));
const Bin_1 = __importDefault(require("./Line/Bin"));
const Browser_1 = __importDefault(require("./Line/Browser"));
const Calendar_1 = __importDefault(require("./Line/Calendar"));
const Carehome_2 = __importDefault(require("./Line/Carehome"));
const Celebrate_1 = __importDefault(require("./Line/Celebrate"));
const Chart_1 = __importDefault(require("./Line/Chart"));
const Chat_1 = __importDefault(require("./Line/Chat"));
const Clock_1 = __importDefault(require("./Line/Clock"));
const Cog_1 = __importDefault(require("./Line/Cog"));
const Collapse_1 = __importDefault(require("./Line/Collapse"));
const Copy_1 = __importDefault(require("./Line/Copy"));
const Cross_1 = __importDefault(require("./Line/Cross"));
const Dashboard_1 = __importDefault(require("./Line/Dashboard"));
const Directory_1 = __importDefault(require("./Line/Directory"));
const Doctor_1 = __importDefault(require("./Line/Doctor"));
const Document_1 = __importDefault(require("./Line/Document"));
const Done_1 = __importDefault(require("./Line/Done"));
const Expand_1 = __importDefault(require("./Line/Expand"));
const Failed_2 = __importDefault(require("./Line/Failed"));
const Filter_1 = __importDefault(require("./Line/Filter"));
const Flag_2 = __importDefault(require("./Line/Flag"));
const Hashtag_1 = __importDefault(require("./Line/Hashtag"));
const HealthProfessional_2 = __importDefault(require("./Line/HealthProfessional"));
const Hospital_2 = __importDefault(require("./Line/Hospital"));
const IdCard_1 = __importDefault(require("./Line/IdCard"));
const Info_2 = __importDefault(require("./Line/Info"));
const Link_1 = __importDefault(require("./Line/Link"));
const List_1 = __importDefault(require("./Line/List"));
const Location_1 = __importDefault(require("./Line/Location"));
const Logout_1 = __importDefault(require("./Line/Logout"));
const Mail_1 = __importDefault(require("./Line/Mail"));
const Mailbox_1 = __importDefault(require("./Line/Mailbox"));
const Medication_1 = __importDefault(require("./Line/Medication"));
const Mention_1 = __importDefault(require("./Line/Mention"));
const Menu_1 = __importDefault(require("./Line/Menu"));
const Message_1 = __importDefault(require("./Line/Message"));
const MessageHealthProfessional_1 = __importDefault(require("./Line/MessageHealthProfessional"));
const MessageV2_1 = __importDefault(require("./Line/MessageV2"));
const MessageWrite_1 = __importDefault(require("./Line/MessageWrite"));
const Messages_1 = __importDefault(require("./Line/Messages"));
const Minimise_1 = __importDefault(require("./Line/Minimise"));
const Minus_1 = __importDefault(require("./Line/Minus"));
const NoPerson_1 = __importDefault(require("./Line/NoPerson"));
const Off_1 = __importDefault(require("./Line/Off"));
const On_1 = __importDefault(require("./Line/On"));
const OpenWindow_1 = __importDefault(require("./Line/OpenWindow"));
const Paperclip_1 = __importDefault(require("./Line/Paperclip"));
const PatientList_1 = __importDefault(require("./Line/PatientList"));
const PenToSquare_1 = __importDefault(require("./Line/PenToSquare"));
const Pencil_1 = __importDefault(require("./Line/Pencil"));
const Person_2 = __importDefault(require("./Line/Person"));
const Phone_1 = __importDefault(require("./Line/Phone"));
const Photo_1 = __importDefault(require("./Line/Photo"));
const Pin_2 = __importDefault(require("./Line/Pin"));
const Plus_1 = __importDefault(require("./Line/Plus"));
const Question_2 = __importDefault(require("./Line/Question"));
const Questionnaire_1 = __importDefault(require("./Line/Questionnaire"));
const Record_1 = __importDefault(require("./Line/Record"));
const RecordPerson_1 = __importDefault(require("./Line/RecordPerson"));
const Refresh_1 = __importDefault(require("./Line/Refresh"));
const Reply_1 = __importDefault(require("./Line/Reply"));
const Save_1 = __importDefault(require("./Line/Save"));
const Search_1 = __importDefault(require("./Line/Search"));
const Send_2 = __importDefault(require("./Line/Send"));
const Slide_1 = __importDefault(require("./Line/Slide"));
const SortDown_1 = __importDefault(require("./Line/SortDown"));
const SortUp_1 = __importDefault(require("./Line/SortUp"));
const Survey_1 = __importDefault(require("./Line/Survey"));
const Swap_1 = __importDefault(require("./Line/Swap"));
const Syringe_1 = __importDefault(require("./Line/Syringe"));
const Tag_1 = __importDefault(require("./Line/Tag"));
const Team_2 = __importDefault(require("./Line/Team"));
const Tick_1 = __importDefault(require("./Line/Tick"));
const TickDouble_1 = __importDefault(require("./Line/TickDouble"));
const Triage_1 = __importDefault(require("./Line/Triage"));
const Unread_1 = __importDefault(require("./Line/Unread"));
const Upload_1 = __importDefault(require("./Line/Upload"));
const Video_1 = __importDefault(require("./Line/Video"));
const Warning_2 = __importDefault(require("./Line/Warning"));
const Window_1 = __importDefault(require("./Line/Window"));
const outlineImports = {
    AccurxLogo: AccurxLogo_2.default,
    Arrow: Arrow_1.default,
    ArrowTail: ArrowTail_1.default,
    Assign: Assign_2.default,
    Assigned: Assigned_2.default,
    Bell: Bell_2.default,
    BellMute: BellMute_1.default,
    Bin: Bin_1.default,
    Browser: Browser_1.default,
    Calendar: Calendar_1.default,
    Carehome: Carehome_2.default,
    Celebrate: Celebrate_1.default,
    Chart: Chart_1.default,
    Chat: Chat_1.default,
    Clock: Clock_1.default,
    Cog: Cog_1.default,
    Collapse: Collapse_1.default,
    Copy: Copy_1.default,
    Cross: Cross_1.default,
    Dashboard: Dashboard_1.default,
    Doctor: Doctor_1.default,
    Document: Document_1.default,
    Done: Done_1.default,
    Expand: Expand_1.default,
    Failed: Failed_2.default,
    Filter: Filter_1.default,
    Flag: Flag_2.default,
    Hashtag: Hashtag_1.default,
    HealthProfessional: HealthProfessional_2.default,
    Hospital: Hospital_2.default,
    IdCard: IdCard_1.default,
    Info: Info_2.default,
    Link: Link_1.default,
    List: List_1.default,
    Location: Location_1.default,
    Mail: Mail_1.default,
    Mailbox: Mailbox_1.default,
    Medication: Medication_1.default,
    Mention: Mention_1.default,
    Menu: Menu_1.default,
    Message: Message_1.default,
    Messages: Messages_1.default,
    MessageWrite: MessageWrite_1.default,
    Minimise: Minimise_1.default,
    Minus: Minus_1.default,
    NoPerson: NoPerson_1.default,
    Off: Off_1.default,
    On: On_1.default,
    OpenWindow: OpenWindow_1.default,
    SortUp: SortUp_1.default,
    SortDown: SortDown_1.default,
    Paperclip: Paperclip_1.default,
    Pencil: Pencil_1.default,
    PenToSquare: PenToSquare_1.default,
    Person: Person_2.default,
    Phone: Phone_1.default,
    Photo: Photo_1.default,
    Pin: Pin_2.default,
    Plus: Plus_1.default,
    Question: Question_2.default,
    Questionnaire: Questionnaire_1.default,
    Record: Record_1.default,
    RecordPerson: RecordPerson_1.default,
    Refresh: Refresh_1.default,
    Reply: Reply_1.default,
    Save: Save_1.default,
    Search: Search_1.default,
    Send: Send_2.default,
    Slide: Slide_1.default,
    Survey: Survey_1.default,
    Syringe: Syringe_1.default,
    Tag: Tag_1.default,
    Team: Team_2.default,
    Tick: Tick_1.default,
    TickDouble: TickDouble_1.default,
    Unread: Unread_1.default,
    Upload: Upload_1.default,
    Video: Video_1.default,
    Warning: Warning_2.default,
    Window: Window_1.default,
    // Temporary preview icons
    "preview-Account": Account_1.default,
    "preview-Logout": Logout_1.default,
    "preview-Swap": Swap_1.default,
    "preview-Triage": Triage_1.default,
    "preview-Message": MessageV2_1.default,
    "preview-MessageHealthProfessional": MessageHealthProfessional_1.default,
    "preview-PatientList": PatientList_1.default,
    "preview-Directory": Directory_1.default,
};
const solidImports = {
    AccurxLogo: AccurxLogo_1.default,
    AddPerson: AddPerson_1.default,
    ArrowOneWay: ArrowOneWay_1.default,
    ArrowTwoWay: ArrowTwoWay_1.default,
    Carehome: Carehome_1.default,
    LockAllowed: Allowed_1.default,
    LockDenied: Denied_1.default,
    LockLocked: Locked_1.default,
    LockUnlocked: Unlocked_1.default,
    Assign: Assign_1.default,
    Assigned: Assigned_1.default,
    Bell: Bell_1.default,
    ColumnThree: ColumnThree_1.default,
    ColumnTwo: ColumnTwo_1.default,
    Dot: Dot_1.default,
    Error: Error_1.default,
    Failed: Failed_1.default,
    Flag: Flag_1.default,
    HealthProfessional: HealthProfessional_1.default,
    Hospital: Hospital_1.default,
    Inbox: Inbox_1.default,
    Info: Info_1.default,
    More: More_1.default,
    Person: Person_1.default,
    Pin: Pin_1.default,
    Question: Question_1.default,
    ReviewPerson: ReviewPerson_1.default,
    SearchPerson: SearchPerson_1.default,
    Send: Send_1.default,
    Star: Star_1.default,
    Success: Success_1.default,
    Team: Team_1.default,
    Unassigned: Unassigned_1.default,
    Warning: Warning_1.default,
};
/**
 * IconStyleVariants is used by the deprecated <Icon theme="Line|Fill"> component
 * We have moved to <Ds.Icon appearance="outline|solid">.
 * Once we deleted all of the old icon we can delete "Line" and "Fill"
 */
exports.paths = {
    Line: outlineImports, // @deprecated use "outline"
    Fill: solidImports, // @deprecated use "solid"
    outline: outlineImports,
    solid: solidImports,
};
//# sourceMappingURL=Paths.js.map